import React from 'react';
import StyleDecorator from './StyleDecorator';
import Radium from 'radium';

class RawHtml extends React.Component {
	static propTypes = {
		inner: React.PropTypes.string.isRequired,
		tag: React.PropTypes.string,
		style: React.PropTypes.object,
	};

	static defaultProps = {
		tag: 'span',
		style: {},
	};

	createMarkup = () => {
		return { __html: this.props.inner };
	};

	render() {
		return (
			/* eslint react/no-danger:0*/
			<this.props.tag
				dangerouslySetInnerHTML={this.createMarkup()}
				style={this.props.style}
			/>
		);
	}
}

export default StyleDecorator(Radium(RawHtml));



// WEBPACK FOOTER //
// ./src/components/RawHtml.js